import styled from '@emotion/styled';
import { color, font } from 'src/shared/styles/variables';

export const ScreenTitle = styled('h1')(
    {
        color: color.bunting,
        lineHeight: '40px',
    },
    font.heavy(font.size.extraLarge),
);
